module.exports = __webpack_public_path__ + "img/用户信息.6221b01e.svg";